import BaseServices from "./BaseServices";

const InventoryServices = {
    GetInventory: async (paging) => {
        return await BaseServices.Post("/api/Inventory/get-inventory", paging);
    },
    ExportExcel: async () => {
        return await BaseServices.Post("/api/Inventory/export-excel");
    },
};

export default InventoryServices;
